<div id="user-settings-ai-assist" class="settings-panel" [class.mobile]="isMobile">
  <div class="head">
    <span class="material-icons go-back" (click)="goBack.emit()"> arrow_back </span>
    <div class="description">
      <div class="title">{{ PANELS.AI_ASSIST.name }}</div>
      <div class="subtitle">{{ PANELS.AI_ASSIST.description }}</div>
    </div>
    <span class="material-icons close" (click)="goBack.emit()"> close </span>
  </div>
  <div class="sub-head" *ngIf="isMobile">
    {{ PANELS.AI_ASSIST.description }}
  </div>
  <div class="panel-body">
    <form [formGroup]="form" (submit)="submitChanges()" class="settings-panel-form">
      <mat-tab-group
        color="primary"
        class="ai-assist-settings-tabs"
        [disableRipple]="true"
        [selectedIndex]="defaultTabIndex"
      >
        <mat-tab [label]="'Post-Session' | translate">
          <div class="tab-section">
            <div class="section-group">
              <h4 class="section-title">{{ 'Session Summaries' | translate }}</h4>
              <div class="toggle-group">
                <app-user-settings-permissions-toggle
                  [formGroup]="form"
                  [options]="{
                    setting: 'crEnableAISummarization',
                    titleText: 'Enable session summaries' | translate,
                    activeText: 'Generate summaries for cloud recorded sessions.' | translate,
                    inactiveText: 'Generate summaries for cloud recorded sessions.' | translate,
                    learnMoreUrl: learnMoreUrls.sessionSummaries,
                    disableOptions: {
                      disabled: (canUseAISummarization$ | async) === false,
                      reason: featureManagementService.featureUnavailableTooltip.message
                    },
                    upgradeOptions:
                      (canUseAISummarization$ | async) === false
                        ? {
                            requiredSubscriptions: proFeatureSubscriptionTypes,
                            evaluationType: UpgradePlanEvaluationType.SELF
                          }
                        : undefined
                  }"
                ></app-user-settings-permissions-toggle>
              </div>
            </div>

            <div class="section-group" *ngIf="aiCoachingInsightsEnabled$ | async">
              <h4 class="section-title">{{ 'Coaching Insights' | translate }}</h4>
              <div class="toggle-group">
                <app-user-settings-permissions-toggle
                  [formGroup]="form"
                  [options]="{
                    setting: 'aiCoachingInsights',
                    titleText: 'Enable coaching insights' | translate,
                    activeText:
                      'Generate coaching insights for cloud recorded sessions.' | translate,
                    inactiveText:
                      'Generate coaching insights for cloud recorded sessions.' | translate,
                    learnMoreUrl: learnMoreUrls.coachingInsights,
                    disableOptions: {
                      disabled: (canUseAICoach$ | async) === false,
                      reason: featureManagementService.featureUnavailableTooltip.message
                    },
                    upgradeOptions:
                      (canUseAICoach$ | async) === false
                        ? {
                            requiredSubscriptions: proFeatureSubscriptionTypes,
                            evaluationType: UpgradePlanEvaluationType.SELF
                          }
                        : undefined
                  }"
                ></app-user-settings-permissions-toggle>
              </div>
            </div>

            <div
              class="section-group"
              *ngIf="(aiSafeguardingUiEnabled$ | async) || (nudityDetectionEnabled$ | async)"
            >
              <h4 class="section-title">{{ 'Safeguarding' | translate }}</h4>
              <div class="toggle-group">
                <app-user-settings-permissions-toggle
                  *ngIf="aiSafeguardingUiEnabled$ | async"
                  [formGroup]="form"
                  [options]="{
                    setting: 'aiSafeguarding',
                    titleText: 'Enable safeguarding alerts' | translate,
                    activeText:
                      'Detect and flag potential safety, conduct, and policy issues in cloud recorded sessions.'
                      | translate,
                    inactiveText:
                      'Detect and flag potential safety, conduct, and policy issues in cloud recorded sessions.'
                      | translate,
                    learnMoreUrl: learnMoreUrls.safeguardingAlerts,
                    disableOptions: {
                      disabled: (canUseAISafeguarding$ | async) === false,
                      reason: featureManagementService.featureUnavailableTooltip.message
                    },
                    upgradeOptions:
                      (canUseAISafeguarding$ | async) === false
                        ? {
                            requiredSubscriptions: proFeatureSubscriptionTypes,
                            evaluationType: UpgradePlanEvaluationType.SELF
                          }
                        : undefined
                  }"
                ></app-user-settings-permissions-toggle>
                <app-user-settings-permissions-toggle
                  *ngIf="nudityDetectionEnabled$ | async"
                  [formGroup]="form"
                  [options]="{
                    setting: 'enableNudityDetectionAlerts',
                    titleText: 'Enable nudity detection' | translate,
                    activeText:
                      'Detect potential nudity during sessions and flag it for admins to review.'
                      | translate,
                    inactiveText:
                      'Detect potential nudity during sessions and flag it for admins to review.'
                      | translate,
                    learnMoreUrl: learnMoreUrls.nudityDetection
                  }"
                ></app-user-settings-permissions-toggle>
              </div>
            </div>

            <div class="section-group">
              <h4 class="section-title">{{ 'Snippets' | translate }}</h4>
              <div class="toggle-group">
                <app-user-settings-permissions-toggle
                  [formGroup]="form"
                  [options]="{
                    setting: 'aiSnippets',
                    titleText: 'Enable snippets' | translate,
                    activeText:
                      'Generate clips of memorable moments for review after each cloud recorded session.'
                      | translate,
                    inactiveText:
                      'Generate clips of memorable moments for review after each cloud recorded session.'
                      | translate,
                    learnMoreUrl: learnMoreUrls.aiSnippets,
                    disableOptions: {
                      disabled: (canUseAISnippets$ | async) === false,
                      reason: featureManagementService.featureUnavailableTooltip.message
                    },
                    upgradeOptions:
                      (canUseAISnippets$ | async) === false
                        ? {
                            requiredSubscriptions: proFeatureSubscriptionTypes,
                            evaluationType: UpgradePlanEvaluationType.SELF
                          }
                        : undefined
                  }"
                ></app-user-settings-permissions-toggle>
                <div
                  class="snippet-visibility-setting"
                  [class.snippet-visibility-setting--disabled]="
                    (canUseAISnippets$ | async) === false ||
                    (snippetsSettings$ | async)?.aiSnippets === false
                  "
                >
                  <div class="snippet-visibility-setting__info">
                    <p class="snippet-visibility-setting__title">
                      {{ 'Snippet visibility for participants' | translate }}
                    </p>
                    <p class="snippet-visibility-setting__description">
                      {{
                        'Determines when participants can access snippets after generation'
                          | translate
                      }}
                    </p>
                  </div>
                  <app-pencil-button
                    class="snippet-visibility-setting__dropdown"
                    [matMenuTriggerFor]="snippetVisibilityMenu"
                    [disabled]="
                      (canUseAISnippets$ | async) === false ||
                      (snippetsSettings$ | async)?.aiSnippets === false
                    "
                    buttonType="button"
                  >
                    <p>{{ (snippetsSettings$ | async)?.triggerLabel }}</p>
                    <app-pencil-icon
                      name="keyboard_arrow_down"
                      [type]="IconTypes.matIcon"
                    ></app-pencil-icon>
                  </app-pencil-button>
                  <mat-menu #snippetVisibilityMenu="matMenu" class="pencil-mat-menu light-scheme">
                    <app-pencil-menu-item
                      *ngFor="let option of snippetVisibilityOptions"
                      [label]="option.label"
                      (click)="setSnippetVisibility(option.value)"
                    >
                      {{ option.label }}
                    </app-pencil-menu-item>
                  </mat-menu>
                </div>
              </div>
            </div>

            <ng-container *ngIf="emailAudienceTable$ | async as emailAudienceTable">
              <div class="section-group" *ngIf="emailAudienceTable.columns.length > 0">
                <div class="section-header">
                  <h4 class="section-title">{{ 'Post-Session Emails' | translate }}</h4>
                  <p class="section-description">
                    {{
                      'Choose who receives post-session emails. Summaries, coaching insights, and snippets are sent together in one email per session.'
                        | translate
                    }}
                  </p>
                </div>

                <div
                  class="post-session-email-table"
                  role="table"
                  [attr.aria-label]="'Post-Session Emails' | translate"
                >
                  <div class="table-header" role="row">
                    <div class="recipients-col" role="columnheader">
                      {{ 'RECIPIENTS' | translate }}
                    </div>
                    <div class="content-cols" role="presentation">
                      <div
                        *ngFor="
                          let column of emailAudienceTable.columns;
                          trackBy: trackByEmailAudienceColumn
                        "
                        class="content-col"
                        role="columnheader"
                      >
                        {{ column.label }}
                      </div>
                    </div>
                  </div>
                  <div
                    *ngFor="let row of emailAudienceTable.rows; trackBy: trackByEmailAudienceRow"
                    class="table-row"
                    role="row"
                  >
                    <div class="recipients-col" role="cell">
                      {{ row.option.label }}
                    </div>
                    <div class="content-cols" role="presentation">
                      <div
                        *ngFor="let cell of row.cells; trackBy: trackByEmailAudienceCell"
                        class="content-col"
                        role="cell"
                      >
                        <mat-checkbox
                          color="primary"
                          [checked]="cell.isSelected"
                          [disabled]="cell.isDisabled"
                          [attr.aria-label]="row.option.label + ' — ' + cell.columnLabel"
                          (change)="
                            onEmailAudienceSelectionChange(
                              $event.checked,
                              cell.audience,
                              cell.settingKey
                            )
                          "
                        ></mat-checkbox>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </mat-tab>

        <mat-tab [label]="'In Session' | translate">
          <div class="tab-section">
            <div class="section-group">
              <h4 class="section-title">{{ 'Engagement Signals' | translate }}</h4>
              <div class="toggle-group">
                <app-user-settings-permissions-toggle
                  *ngIf="inactivityNotificationsEnabled$ | async"
                  [formGroup]="form"
                  [options]="{
                    setting: 'inactivityNotifications',
                    titleText: 'Enable distraction notifications' | translate,
                    disableOptions: {
                      disabled: !inactivityNotificationsPaid,
                      reason:
                        'This feature is only available for Pencil Spaces Pro users' | translate
                    },
                    upgradeOptions: {
                      requiredSubscriptions:
                        foregroundInactivityNotificationsService.requiredSubscriptionTypes,
                      evaluationType: UpgradePlanEvaluationType.SELF
                    },
                    activeText:
                      'Notify hosts when participants are inactive or not focused on the Space during a call'
                      | translate,
                    inactiveText:
                      'Notify hosts when participants are inactive or not focused on the Space during a call'
                      | translate
                  }"
                ></app-user-settings-permissions-toggle>
                <app-user-settings-permissions-toggle
                  *ngIf="liveCallAlertsEnabled$ | async"
                  [formGroup]="form"
                  [options]="{
                    setting: 'liveCallAlerts',
                    titleText: 'Enable speaking feedback' | translate,
                    activeText:
                      'Give hosts real-time signals on speaking pace and talk time to support student engagement'
                      | translate,
                    inactiveText:
                      'Give hosts real-time signals on speaking pace and talk time to support student engagement'
                      | translate,
                    disableOptions: {
                      disabled: (canUseLiveCallAlerts$ | async) === false,
                      reason: featureManagementService.featureUnavailableTooltip.message
                    },
                    upgradeOptions:
                      (canUseLiveCallAlerts$ | async) === false
                        ? {
                            requiredSubscriptions: proFeatureSubscriptionTypes,
                            evaluationType: UpgradePlanEvaluationType.SELF
                          }
                        : undefined
                  }"
                ></app-user-settings-permissions-toggle>
              </div>
            </div>
          </div>
        </mat-tab>
      </mat-tab-group>

      <div class="foot" [class.show]="formChanged$ | async">
        <app-pencil-button
          class="pencil-button btn-ok"
          [buttonType]="'submit'"
          [disabled]="form.invalid"
        >
          <span *ngIf="!isLoading" class="material-icons">check</span>
          <mat-spinner *ngIf="isLoading" [diameter]="16" color="#FFF"></mat-spinner>
          <span>{{ 'Update' | translate }}</span>
        </app-pencil-button>
        <app-pencil-button
          [buttonType]="'button'"
          class="pencil-button btn-cancel"
          (clickEvent)="initForm()"
          type="button"
          icon="close"
          [iconConfig]="{ type: 'material-icon' }"
          [label]="'Cancel' | translate"
        >
        </app-pencil-button>
      </div>
    </form>
  </div>
</div>
